import { fetchLiveLocation } from "@/ServerActions";
import { DataResponse, LiveLocation } from "@/types";
import { useQuery } from "@tanstack/react-query";

type LiveLocationData = {
  features: LiveLocation[];
  type: "FeatureCollection";
};

export const useDriversLocations = () => {
  return useQuery<DataResponse<LiveLocationData>>({
    queryKey: ["livelocations", "DotAdmin"],
    queryFn: () => fetchLiveLocation(),
    refetchInterval: 5000,
    gcTime: 0,
  });
};
